export default __webpack_public_path__ + "static/gold_fish_5-0ab06ff2b020224a74d753361b0c9c83.png";